__webpack_require__.p = "/Amazon-clone-react/";